import { ContentCard, Button, SelectGeneric, Accordion } from 'ypf-pas-general-ui-components';
import { Col, Row } from 'react-bootstrap';
import { useFormik } from 'formik';

import './ProvisionReport.scss';
import useToast from '../../hooks/useToast';
import postDownloadProvisionReport from '../../services/provisionReportService';
import { getProvisionContract } from '../../services/adminContracts';
import {
  provisionReportFilterAdapter,
  contractRespAdapter
} from '../../adapters/provisionReport/provisionReportAdapter';

const initialValues = {
  numeroContrato: []
};

const ProvisionReport = () => {
  const formik = useFormik({
    initialValues
  });
  const { setNewToast } = useToast();

  const onClean = () => {
    formik.setValues(initialValues);
  };

  const downloadReport = async () => {
    try {
      setNewToast({
        type: 'INFO',
        message: 'Sus archivos se están descargando. Por favor, no actualice la página.'
      });
      await postDownloadProvisionReport(provisionReportFilterAdapter(formik.values));
      setNewToast({
        type: 'SUCCESS',
        message: 'Sus archivos han sido descargados!'
      });
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    }
  };

  const searchContract = async (name) => {
    let contratos = null;

    if (name.length < 3) return null;
    await getProvisionContract(name)
      .then((res) => {
        contratos = contractRespAdapter(res);
      })
      .catch((err) => {
        setNewToast({
          type: 'ERROR',
          message: err.message
        });
      });

    return contratos;
  };

  return (
    <div className="pas-container fluid-75">
      <h2 className="pas-title ">Reporte de Provisión</h2>
      <ContentCard className="px-4 mb-4" orientation="vertical">
        <Row className="my-3 mx-0 px-2">
          <div
            className="d-flex mb-0 pb-0"
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 0 12px 10px'
            }}
          >
            <h3 className="pas-title mb-0">Filtros</h3>
          </div>
          <div className="m-0 p-0">
            <hr className="reportSectionTitle" />
          </div>
        </Row>
        <Accordion className="mb-3" key="notificacion" markContent="close" title="Notificación">
          <Row className="m-2">
            <h6>Contrato</h6>
            <SelectGeneric
              async
              clearable
              fetchData={searchContract}
              isMulti
              name="numeroContrato"
              noOptionsMessage="Ingresar al menos 3 caracteres"
              onChange={(newValues) => formik.setFieldValue('numeroContrato', newValues)}
              placeholder="Buscar contratos"
              value={formik.values.numeroContrato}
              withSelect="100%"
            />
          </Row>
        </Accordion>
      </ContentCard>
      <div className="d-flex justify-content-center align-items-center mb-4">
        <Col sm={2}>
          <Button
            label="Limpiar filtros"
            onClick={onClean}
            type="button"
            variant="outline-primary"
            widthButton="150px"
          />
        </Col>
        <Col sm={2}>
          <Button
            label="Generar reporte"
            onClick={downloadReport}
            type="button"
            variant="primary"
            widthButton="150px"
          />
        </Col>
      </div>
    </div>
  );
};

export default ProvisionReport;
